export interface IConsultaConfiguracaoNFe {
    guid: string,
    codigoFrota: number
}

export interface IArquiveiModel {
    codigoFrota: number
    flagAceite: number,
    loginAceite: string,
    dataAceite: string | null
}

export interface IParametroReagendamento {
    guid: string,
    habilitado: string,
    codigoFrota: number,
    codigoParametroBloqueio?: number | null,
    dataInicioOperacao?: string | null,
    dataInicioReagendamento?: string | null,
    tipoReagendamento?: string | null,
    qtdeDiasAposFechamentoCiclo?: number | null
}

export interface IParametroConciliacao {
    guid: string,
    tipoConciliacao: string,
    flagEmissaoUF: string,
    codigoFrota: number,
    codigoParametroFrota?: number | null,
    valorFixoAceite?: number | null
}

export interface IConsultaArquiveiModel {
    retorno?: IArquiveiModel,
    sucesso: boolean,
    mensagens: string[]
}

export interface IConsultaParametroReagendamentoModel {
    retorno?: IParametroReagendamento,
    sucesso: boolean,
    mensagens: string[]
}

export interface IConsultaParametroConciliacaoModel {
    retorno?: IParametroConciliacao,
    sucesso: boolean,
    mensagens: string[]
}

export interface IRetornoConfiguracaoModel {
    retorno: boolean,
    sucesso: boolean,
    mensagens: string[]
}